import { NO_PATTERN_BUSINESS_LOGIC, Link, createComponentById } from '@vfde-brix/ws10/core';
import { HtmlId } from '../enums/elementId';
import {
    UnorderedHorizontalList,
    createUnorderedHorizontalList,
} from '@vfde-brix/ws10/unordered-horizontal-list';
import { getCMSConfig } from '../util/cms';
import { JarvisProduct } from '@vfde-sails/avc-core';

export const mountHorizontalList = (wrapperId: HtmlId) =>
    createComponentById(createUnorderedHorizontalList, wrapperId, NO_PATTERN_BUSINESS_LOGIC);

export const updateTariffLinks = (comp: UnorderedHorizontalList | null, selectedProduct?: JarvisProduct) => {
    const { productInfo, afterVpProductInfo } = selectedProduct || {};
    const tariffLink = afterVpProductInfo || productInfo;

    if (!comp || !tariffLink) {
        return;
    }

    const props = comp.getProperties();

    if (2 > props.items.length) {
        return;
    }

    const priceListLink: Link = {
        stdLinkUrl: getCMSConfig()?.priceListLink || '',
    };

    const productLink: Link = {
        stdLinkUrl: tariffLink,
    };

    props.items[0].link = priceListLink;
    props.items[1].link = productLink;

    comp.update(props);
};
